import { getShortLanguage } from '@transsion/utils/detect'
import { snakeCase } from '@transsion/utils/string'

import { ENV_BASE_URL_MAP, PROD_BASE_URL_MAP } from './constants'
import type { Env, ServerLocation, ServiceType } from './types'

/**
 * 获取默认的 store 保存前缀
 *
 * @param appCode 应用编码
 * @returns ｛String｝
 */
export function getDefaultStorePrefixKey(appCode: string): string {
  return `${snakeCase(appCode)}_`
}

/**
 * 获取默认的 base url
 *
 * @param serviceType 服务类型
 * @param env 环境
 * @param location 地区
 * @returns ｛String}
 */
export function getDefaultBaseUrl(
  serviceType: ServiceType,
  env: Env = 'prod',
  location: ServerLocation = 'hk',
): string {
  switch (env) {
    case 'dev':
    case 'sit':
    case 'uat': {
      return ENV_BASE_URL_MAP[env][serviceType]
    }

    default: {
      return PROD_BASE_URL_MAP[serviceType][location]
    }
  }
}

export function getFallbackLanguage() {
  return getShortLanguage()
}
